import { isEmpty } from 'lodash'

const IS_IFRAMED = 'is_iframed'

const checkIsInIframe = () => {
    if (typeof sessionStorage !== 'undefined') {
        return Boolean(sessionStorage?.getItem(IS_IFRAMED))
    }
    return false
}

const getQueryPartOnIFramed = (shouldAddSlashBeforeIFrameQuery = false) =>
    checkIsInIframe() ? `${shouldAddSlashBeforeIFrameQuery ? '/' : ''}iframe` : ''

const checkIsContainsIFrameQuery = (uri = '') => {
    if (isEmpty(uri)) return false

    const uriParts = uri.split('/').filter(part => !isEmpty(part))

    if (isEmpty(uriParts)) return false
    return uriParts[0] === 'iframe'
}

const setIsIFramed = (isIFramed = true) =>
    isIFramed ? sessionStorage.setItem(IS_IFRAMED, 'true') : sessionStorage.removeItem(IS_IFRAMED)

export {
    IS_IFRAMED,
    getQueryPartOnIFramed,
    setIsIFramed,
    checkIsInIframe,
    checkIsContainsIFrameQuery,
}
